import styled, { css } from 'styled-components'

export const Soles = styled.div`
  display: flex;
  gap: 1rem;
`

export const SoleImage = styled.img<{ selected?: boolean }>`
  width: 7rem;
  padding: 0.5rem;
  height: auto;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid
    ${({ selected = false, theme }) =>
      selected ? theme.colors.primary : theme.colors.border};
  ${({ selected = false }) => {
    return (
      !selected &&
      css`
        opacity: 0.5;
      `
    )
  }}

  &:hover {
    opacity: 1;
    transition: all 0.15s ease-in-out;
    border-bottom-color: ${({ theme }) => theme.colors.primary};
  }
`
